<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>

    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div v-if="showPesquisa">
        <div class="form-edit-page row-space">
            <div class="row-start">
                <div class="form-item flexible">
                    <label class="label-caption">Pesquisa Nome</label>
                    <input type="text" v-model="nmPesquisa" maxlength="60" v-uppercase />
                </div>
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
        
        <table>
            <thead>
                <tr>
                    <th>Nome</th>
                    <th class="col-width-char40">Bairro</th>
                    <th class="col-width-char20">Fone</th>
                    <th class="col-width-integer">Qtdd OS</th>
                    <th class="col-width-number">Total OS</th>
                    <th class="col-width-number">Banco</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}" @click="setEdicao(obj)">
                    <td>{{ obj.nmpessoa }}</td>
                    <td class="col-width-char40">{{ obj.nmbairro }}</td>
                    <td class="col-width-char20">{{ obj.fone }}</td>
                    <td class="col-width-integer right">{{ Funcoes.formatInteger(obj.os_qtd) }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.os_total) }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.ttvlsaldo_banco) }}</td>
                </tr>
            </tbody>
        </table>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />

            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>

            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>

    <div v-if="!showPesquisa && !showCobranca">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 90px;">
                    <label class="label-caption">Produtor</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.cdpessoa) }}</div>
                </div>

                <div class="form-item flexible">
                    <label class="label-caption">Nome</label>
                    <div class="field-label">{{ objEdicao.nmpessoa }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Fone</label>
                    <div class="field-label field-label-center">{{ objEdicao.fone }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">CPF/CNPJ</label>
                    <div :class="{
                        'field-label-alert': !objEdicao.cpfcnpj,
                        'field-label': objEdicao.cpfcnpj,
                        'field-label-center': true
                    }">{{ objEdicao.cpfcnpj }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">CEP</label>
                    <div :class="{
                        'field-label-alert': !objEdicao.cep,
                        'field-label': objEdicao.cep,
                        'field-label-center': true
                    }">{{ objEdicao.cep }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item-number">
                    <label class="label-caption">Total R$</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatDecimal(objEdicao.os_total - objEdicao.ttvlsaldo_banco) }}</div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Parcelas</label>
                    <select v-model="edParcelas">
                        <option v-for="parcela in opcoesParcelas" :key="parcela" :value="parcela">{{ parcela }}</option>
                    </select>
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Vencimento</label>
                    <input type="date" v-model="edVencimento" />
                </div>

                <div class="form-item-number">
                    <label class="label-caption">1ª Parcela*</label>
                    <input type="text" class="input-right" v-model="edValor" v-decimal-mask/>
                </div>

                <div class="form-item-char30">
                    <label class="label-caption">Nro Título</label>
                    <input type="text" v-model="edTitulo" maxlength="30" v-uppercase />
                </div>

                <div class="form-item">
                    <label class="label-caption">Informações</label>
                    <input type="text" v-model="edInfo" maxlength="200" v-uppercase />
                </div>
            </div>


            <div class="row-end">
                <button class="btn-confirm" @click="salvarCobranca">Salvar</button>
                <button class="btn-cancel" @click="lerDados(); showPesquisa=true">Cancelar</button>
            </div>
        </div>


        <table>
            <thead><tr>
                <th class="col-width-integer">OS</th>
                <th class="col-width-date">Emissão</th>
                <th class="col-width-date">Execução</th>
                <th class="col-width-char30">Grupo</th>
                <th>Serviço</th>
                <th class="col-width-char05">Horas</th>
                <th class="col-width-number">Valor</th>
                <th class="col-width-number">Banco</th>
                <th class="col-width-char10">Ações</th>
            </tr></thead>
            <tbody>
                <tr v-for="(obj, index) in lsOs" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                    <td class="col-width-integer right">{{ obj.cdos }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtinclusao) }}</td>
                    <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtfim) }}</td>
                    <td class="col-width-char30">{{ obj.nmgrupo }}</td>
                    <td>{{ obj.nmservico }}</td>
                    <td class="col-width-char05 center">{{ obj.hrcontratadas }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlhr_total) }}</td>
                    <td class="col-width-number right">{{ Funcoes.formatDecimal(obj.vlbanco) }}</td>
                    <td class="col-width-char10 center label-link" @click="removerItem(obj, index)">REMOVER</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div v-if="showCobranca">
        <CobrancaViewPage :idView="idCobrancaView" @close="closeForm" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/utils';
import { genericPost, genericPut } from '@/funcoes/api'; 
import { globalStore } from '@/globals';
import CobrancaViewPage from './CobrancaViewPage.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close']);
const idCobrancaView = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);
const nmPesquisa = ref(null);
const objEdicao = ref(null);
const showCobranca = ref(false);
const showPesquisa = ref(true);

const edParcelas = ref(1);
const opcoesParcelas = [1, 2, 3, 4, 5, 6];
const edVencimento = ref(null);
const edValor = ref(null);
const edTitulo = ref(null);
const edInfo = ref(null);

const lsOs = ref([]);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        msgAlerta.value  = null;
        isLoading.value     = true;
        const req = await genericPost('/financeiro/os/gerar/resumo', {
            idmunicipio: globalStore.idmunicipio,
            nmpesquisar: nmPesquisa.value});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){
        // Verifica se a API retornou um erro esperado
        if (error.response && error.response.data) {
            msgAlerta.value = error.response.data; // Pega a mensagem da API
        } else {
            msgAlerta.value = 'Erro desconhecido. Tente novamente.';
        }
    } finally {isLoading.value = false;}
}

const removerItem = (obj, index) =>{
    if (lsOs.value.length===1){
        msgAlerta.value = 'Comando não autorizado. Existe apenas UM registro para gerar cobrança';
        return;
    }
    lsOs.value.splice(index,1);
    if (obj.idos){
        objEdicao.value.os_qtd   = (objEdicao.value.os_qtd   - 1);
        objEdicao.value.os_total = (objEdicao.value.os_total - obj.vlhr_total);
    }else if (obj.idbanco){
        objEdicao.value.ttvlsaldo_banco = (objEdicao.value.ttvlsaldo_banco - obj.vlbanco);
    }
}

const salvarCobranca = async() =>{
    try{
        Funcoes.validarData(edVencimento.value);
        msgAlerta.value = null;
        isLoading.value = true;
        const retCobranca = await genericPut('/cad/cobranca', {
            idmunicipio: globalStore.idmunicipio,
            idpessoa: objEdicao.value.idpessoa,
            dtcobranca: Funcoes.strDataAtual(),
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario
        });
        if (retCobranca.bolok===1){
            // GRAVAR ÍTENS/OS
            for (const os of lsOs.value){
                const retOs = await genericPut('/cad/cobranca_item', {
                    idcobranca: retCobranca.id,
                    idbancohrmov: os.idbanco,
                    idos: os.idos,
                    vlservicos: os.vlhr_total,
                    vlhoras_debito: (os.vlbanco > 0) ? 0 : (-1 * os.vlbanco),
                    vlhoras_credito: (os.vlbanco > 0) ? os.vlbanco : 0,
                    idlogin: globalStore.idlogin,
                    idusuario: globalStore.idusuario
                });
                if (retOs.bolok!=1){
                    msgAlerta.value=retOs.erro;
                }
            }

            // GRAVAR PARCELAS
            await genericPost('/financeiro/gerar/parcelas', {
                id: retCobranca.id,
                datainicial: edVencimento.value,
                intparam1: edParcelas.value,
                double1: Funcoes.decimalFromString(edValor.value),
                strparam1: edTitulo.value,
                strparam2: edInfo.value,
                idlogin: globalStore.idlogin,
                idusuario: globalStore.idusuario
            });
                
            idCobrancaView.value = retCobranca.id;
            showCobranca.value   = true;
        }else{msgAlerta.value=retCobranca.erro;}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}

const setEdicao = async(obj) =>{
    try{
        msgAlerta.value      = null;
        isLoading.value         = true;
        objEdicao.value         = obj;
        showPesquisa.value      = false;
        edParcelas.value        = 1;

        // LISTA ORDENS SE SERVIÇO PENDENTES
        const req               = await genericPost('/financeiro/os/gerar/listagem', {
            idmunicipio: globalStore.idmunicipio,
            idpessoa: objEdicao.value.idpessoa});
        lsOs.value = req;
    } catch (error){msgAlerta.value=error;
    } finally {isLoading.value = false;}
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(()=>{
    const dataVencimento = new Date();
    dataVencimento.setDate(dataVencimento.getDate() + globalStore.cobr_prazo_inicial);
    edVencimento.value = Funcoes.formatDate(dataVencimento);
    edVencimento.value = dataVencimento.toISOString().slice(0, 10);
})
</script>
